import { Container, Paper } from '@mui/material';
import type { ReactNode } from 'react';

export default function ContainerPaper({ children }: { children: ReactNode }) {
  return (
    <Container>
      <Paper elevation={8} sx={{ borderRadius: 2, p: 2 }}>
        {children}
      </Paper>
    </Container>
  );
}
